import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
import i18n from '@/i18n';
import { EMAIL_CAMPAIGNS_API_URL } from './url';
export async function getCampaignFormSchema() {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    if (!brand?.id) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.brand-id-not-available'));
    }
    if (!tokenV3) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.auth-token-not-available'));
    }
    const emailCampaignsApi = EMAIL_CAMPAIGNS_API_URL?.replace(/\/$/, '') || '';
    const base = emailCampaignsApi || endpointVersion('v3');
    const url = `${base}/campaign/email/getColumns`;
    const res = await axios.get(url, {
        params: { brand_id: brand.id },
        ...(tokenV3 && { headers: { Authorization: `Bearer ${tokenV3}` } }),
    });
    return res.data;
}
